module.exports = __webpack_public_path__ + "img/blueAdd.2f1e07f3.png";